import { useCallback } from "react";

import useClient from "hooks/useClient";

const useUpdateEmailSetting = () => {
  const { client } = useClient();

  const updateEmailSetting = useCallback(
    async (emailNotification: "ALL" | "NONE") => {
      const { status } = await client({
        method: "put",
        url: `/news/user/email-setting`,
        data: { emailNotification },
      });
      return status;
    },
    [client]
  );

  return { updateEmailSetting };
};

export default useUpdateEmailSetting;
